import { Directive, OnInit, OnChanges, Input, Output, EventEmitter, ElementRef, SimpleChanges } from "@angular/core";
import { GoogleMapsInitializer } from "src/app/services/app/googlemap-key-service/google-maps-initializer.service";

@Directive({
  selector: '[googlePlace]'
})
export class GooglePlaceDirective implements OnInit, OnChanges {
  @Input() radius: {
    center: { lat: number; lng: number };
    miles: number;
  } | null = null;

  @Output() onSelect = new EventEmitter<any>();

  private element: HTMLInputElement;
  private autocomplete: any = null;

  constructor(
    private elRef: ElementRef<HTMLInputElement>,
    private googleMapsLoader: GoogleMapsInitializer
  ) {
    this.element = this.elRef.nativeElement;
  }

  ngOnInit(): void {
    this.googleMapsLoader.initialize().then(() => {
      const options = this.radius ? this.setupOptions(this.radius) : {};
      this.initAutocomplete(options);
    }).catch((err) => {
      console.error('Failed to initialize Google Maps API:', err);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['radius'] && changes['radius'].currentValue && this.autocomplete) {
      const options = this.setupOptions(changes['radius'].currentValue);
      this.autocomplete.setOptions(options);
    }
  }

  private setupOptions(radius: { center: { lat: number; lng: number }; miles: number }) {
    const { center, miles } = radius;
    const offset = (miles * 1.609344) / 100;

    return {
      bounds: {
        north: center.lat + offset,
        south: center.lat - offset,
        east: center.lng + offset,
        west: center.lng - offset,
      },
      strictBounds: true,
    };
  }

  private initAutocomplete(options?: google.maps.places.AutocompleteOptions): void {
    this.autocomplete = new google.maps.places.Autocomplete(this.element, options || {});
    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      this.onSelect.emit(place);
    });
  }
}
